export default "__VITE_ASSET__a9cde62b__"